<template>
  <lazy-component>
    <div class="video-wrapper">
      <iframe
        class="video-iframe"
        width="100%"
        height="100%"
        :src="src"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen
      ></iframe>
    </div>
  </lazy-component>
</template>

<script>
export default {
  name: "AppYoutube",
  props: {
    videourl: {
      type: String,
      required: true
    },
    showinfo: {},
    rel: {
      default: false
    },
    loop: {
      default: false
    },
    controls: {
      default: false
    },
    end: {},
    start: {}
  },
  computed: {
    src() {
      const youtubeIdRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
      const match = this.videourl.match(youtubeIdRegex);

      if (match[1]) {
        return `https://www.youtube.com/embed/${match[1]}`;
      }

      return null;
    }
  }
};
</script>

<style scoped lang="scss">
.video-wrapper {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;

  .video-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
